import { render } from "./InternalReferences.vue?vue&type=template&id=7a7c0fb4&scoped=true"
import script from "./InternalReferences.vue?vue&type=script&lang=js"
export * from "./InternalReferences.vue?vue&type=script&lang=js"

import "./InternalReferences.vue?vue&type=style&index=0&id=7a7c0fb4&scoped=true&lang=css"

import exportComponent from "/var/www/driveapp2.experimental.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7c0fb4"]])

export default __exports__